export default {
      id: "info-circle-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.a60dffc6.svg#info-circle",
      toString: function () {
        return this.url;
      }
    }